// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyCloneWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyCloneWebApiHandler_clone } from '@zg-rentals/ts-rental-manager-api-beta-client';

import type { ListingAlias, UserPropertyCloneResponseWebDto } from '@zg-rentals/ts-rental-manager-api-beta-client';

interface CloneParams {
  fullAddress: string;
  listingAlias: ListingAlias;
  unit?: string;
}

export interface RentalManagerUserPropertyCloneWebApiHandler_clone_Args {
  getParams: CloneParams;
}

export type RentalManagerUserPropertyCloneWebApiHandler_clone_Options = UseMutationOptions<
  UserPropertyCloneResponseWebDto,
  unknown,
  RentalManagerUserPropertyCloneWebApiHandler_clone_Args
>;

/**
 * Clone a property
 */
export const useRentalManagerUserPropertyCloneWebApiHandler_clone = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyCloneWebApiHandler_clone_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyCloneWebApiHandler_clone_Args) =>
      RentalManagerUserPropertyCloneWebApiHandler_clone(args.getParams, httpClient),
  });
};
